import Grid from '@mui/material/Grid';
import TextFieldComp from '../../../components/TextField/textFieldComp';
import Box from '@mui/material/Box';
import ButtonComp from '../../../components/Button/buttonComp';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { fetchDynamicOptions } from '../../../utils/appUtils';
import DropdownTextComp from '../../../components/Dropdown/dropDownTextComp';

function AddEditEmailTemplateMaster({
    closeModal = () => { },
    type = 'add',
    selectedRowObject = {},
    upsertEmailTemplateApi,
    selectedVendors,
}) {

    const [dropdownOptions, setDropdownOptions] = useState([]);

    useEffect(() => {
        callDropdownApi();
    }, []);

    const callDropdownApi = async () => {
        const payload = {
            categoryType: 'Parallel workflow',
        };
        const options = await fetchDynamicOptions(payload);
        const filteredOptions = options?.filter(
            option => !selectedVendors?.includes(option),
        ) || [];
        setDropdownOptions(filteredOptions);
    };


    const validationSchema = Yup.object().shape({
        vendorType: Yup.string()
            .matches(/^[A-Za-z\s]{1,100}$/, 'Invalid Vendor Type')
            .required('Vendor Type is required'),
        subject: Yup.string()
            .max(200, 'Subject must be at most 200 characters')
            .required('Subject is required'),
        htmlTemplate: Yup.string()
            .required('HTML Template is required'),
    });

    const formik = useFormik({
        initialValues:
            type === 'add'
                ? {
                    id: '',
                    vendorType: '',
                    subject: '',
                    htmlTemplate: '',
                }
                : selectedRowObject,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async values => {
            console.log(values, 'VAlues');
            try {
                await upsertEmailTemplateApi(values);
                closeModal();
            } catch (error) {
                console.error('API Error:', error);
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={12}>
                        <DropdownTextComp
                            label={'Vendor Type'}
                            name={'vendorType'}
                            required
                            selectedValue={formik.values['vendorType'] ?? ''}
                            handleChange={formik.handleChange}
                            options={dropdownOptions}
                            error={
                                formik.touched['vendorType'] &&
                                Boolean(formik.errors['vendorType'])
                            }
                            errorMessage={
                                formik.touched['vendorType'] && formik.errors['vendorType']
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextFieldComp
                            label={'Subject'}
                            name={'subject'}
                            required
                            value={formik.values['subject'] ?? ''}
                            onChange={formik.handleChange}
                            error={
                                formik.touched['subject'] &&
                                Boolean(formik.errors['subject'])
                            }
                            errorMessage={
                                formik.touched['subject'] && formik.errors['subject']
                            }
                            onBlur={formik.handleBlur}
                            maxLength={200}
                            multiline
                            rows={2}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextFieldComp
                            label={'HTML Template'}
                            name={'htmlTemplate'}
                            required
                            value={formik.values['htmlTemplate'] ?? ''}
                            onChange={formik.handleChange}
                            error={
                                formik.touched['htmlTemplate'] &&
                                Boolean(formik.errors['htmlTemplate'])
                            }
                            errorMessage={
                                formik.touched['htmlTemplate'] && formik.errors['htmlTemplate']
                            }
                            onBlur={formik.handleBlur}
                            multiline
                            rows={4}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            variant="outlined"
                            className="text-bold-16px"
                            value="Cancel"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#F37021"
                            borderRadius="8px"
                            border="1px solid #F37021"
                            onClick={closeModal}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            type="submit"
                            className="text-bold-16px"
                            value={type === 'add' ? 'Add' : 'Save'}
                            disabled={!formik.dirty || !formik.isValid}
                            gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#fff"
                            borderRadius="8px"
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
}

AddEditEmailTemplateMaster.propTypes = {
    closeModal: PropTypes.func,
    type: PropTypes.string,
    selectedRowObject: PropTypes.object,
    upsertEmailTemplateApi: PropTypes.func.isRequired,
    selectedVendors: PropTypes.any,
};

export default AddEditEmailTemplateMaster;
